import { useQuery } from '@tanstack/react-query';

import { MonitoringHealthPayStationDetail } from 'src/features/monitoring/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/monitoring/health/pay-stations/:payStationId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    payStationId: string;
}

const queryFn = ({ parkingId, payStationId }: DTO): Promise<MonitoringHealthPayStationDetail> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, payStationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload.payStationId],
        queryFn: async () => await queryFn(payload),
        // WS HEALTH_STATUS_UPDATED invalidates this query on real changes, so a
        // long stale window avoids redundant refetches when the user opens/closes
        // hover cards in quick succession.
        staleTime: 5 * 60 * 1000,
        ...config,
    });

export { RESOURCE as GET_MONITORING_HEALTH_PAY_STATION_RESOURCE, useQueryHook as useGetMonitoringHealthPayStation };
